/* eslint-disable */
export default {
  schedule: 'Meeting plannen',
  prompt: 'Geef RingCentral toestemming voor toegang tot uw accountgegevens.',
  saveAsDefault: 'Opslaan als standaard',
  launchMeeting: 'Meeting openen',
} as const;

// @key: @#@"schedule"@#@ @source: @#@"Schedule Meeting"@#@
// @key: @#@"prompt"@#@ @source: @#@"Please authorize RingCentral to access your account information."@#@
// @key: @#@"saveAsDefault"@#@ @source: @#@"Save as default"@#@
// @key: @#@"launchMeeting"@#@ @source: @#@"Launch Meeting"@#@
